import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';
import '../portal/application.scss';
import { InitializationHelpers } from '../portal/portalHelpers';

Rails.start();
window.Turbolinks = Turbolinks;
Turbolinks.start();

document.addEventListener('turbolinks:load', InitializationHelpers.onLoad);

document.addEventListener('turbolinks:before-render', function (event) {
  [
    'cw-widget-holder',
    'cw-bubble-holder',
    'cw-widget-overlay',
    'cw-widget-styles',
  ].forEach(
    function (id) {
      var el = document.getElementById(id);
      if (el && !event.data.newBody.querySelector('#' + id)) {
        event.data.newBody.appendChild(el);
      }
    }
  );
});
